var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/home/parts/mapmodulestorouter',["require", "exports", "common/parts"], function (require, exports, Parts) {
    "use strict";
    var MapModulesToRouter = (function (_super) {
        __extends(MapModulesToRouter, _super);
        function MapModulesToRouter(router) {
            _super.call(this);
            this._router = router;
        }
        MapModulesToRouter.prototype.process = function (symbol) {
            var _this = this;
            var navigation = symbol.item3;
            Enumerable.From(navigation.children)
                .ForEach(function (n) { return _this.map(n); });
            this.output.call(symbol);
        };
        MapModulesToRouter.prototype.map = function (node) {
            var _this = this;
            var moduleId = "home/viewmodels/placeholder";
            var navigation = false;
            var title = node.name;
            if (node.type == "Application" && (node.children.length === 0 || node.disableNavigateToFirstChild)) {
                if (node.application != null) {
                    moduleId = node.application.isExternalApp ? "home/viewmodels/container" : node.application.configuration.moduleId;
                    title = node.application.name;
                }
                navigation = true;
            }
            else if (node.type == "ApplicationLink") {
                if (node.raw.data.route.indexOf("local://") >= 0) {
                    moduleId = "home/viewmodels/help"; //TODO: Sub auswerten
                }
                else if (node.parent.application.isExternalApp) {
                    moduleId = "home/viewmodels/container";
                }
                navigation = true;
            }
            this._router.map({ route: node.uri.absolute, moduleId: moduleId, title: title, nav: navigation });
            // child routing
            if (node.application != null && node.application.configuration.deepLinks != null) {
                Enumerable.From(node.application.configuration.deepLinks)
                    .ForEach(function (x) {
                    var route = node.uri.absolute + "/" + x.path;
                    var module = node.application.configuration.area + "/viewmodels/" + x.module;
                    _this._router.map({ route: route, moduleId: module, title: title, nav: false });
                });
            }
            // childs durchgehen
            Enumerable.From(node.children)
                .ForEach(function (n) { return _this.map(n); });
        };
        return MapModulesToRouter;
    }(Parts.Part));
    return MapModulesToRouter;
});

